import { BringgFontIcons } from '@bringg/bringg-icons';

import { CapacityUtilizationHeader } from './capacity-utilization-header';

import './capacity-utilization-card.scss';

interface CapacityUtilizationHeaderProps {
	iconName: BringgFontIcons;
	headerLabel: string;
	usedCount: number;
	totalCount: number;
	countUnit?: string;
	footer: string;
	className?: string;
	reservedLabel?: string;
}

export const CapacityUtilizationCard = ({
	iconName,
	headerLabel,
	usedCount,
	totalCount,
	countUnit,
	footer,
	className,
	reservedLabel
}: CapacityUtilizationHeaderProps) => {
	return (
		<div className={['capacityUtilizationCard', className].filter(Boolean).join(' ')}>
			<CapacityUtilizationHeader iconName={iconName} label={headerLabel} />
			<div className="cardBody">
				<span className="usedCount">{usedCount}</span>{' '}
				{reservedLabel && <span className="reservedCount">{reservedLabel}</span>}{' '}
				<span className="totalCunt">
					/ {totalCount}
					{countUnit ? ` ${countUnit}` : ''}
				</span>
			</div>
			<span className="cardFooter">{footer}</span>
		</div>
	);
};
